define.alias("ember-math-helpers/helpers/max", "calendar/helpers/max");